"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FOLDER = exports.FILES = void 0;
const FILES = exports.FILES = 'file_based_collection';
const FOLDER = exports.FOLDER = 'folder_based_collection';